module.exports = __webpack_public_path__ + "static/media/meditation11.9467972b.mp3";